/* eslint-disable no-unused-vars */
import { Button, CardContent, Grid, TextField } from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";

import Card from "../../components/Card/Card";

import db from "../../db/db";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { DesktopDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AsyncSelect from "react-select/async";

const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginLeft: 5,
        },
        input: {
          padding: 6,
          marginLeft: 2,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingTop: 5,
          paddingBottom: 5,
          paddingRight: 15,
          "&:last-child": { paddingBottom: 5 },
        },
      },
    },
  },
});

export default function SaleDetailsPanel(props) {
  const { t } = useTranslation();
  const translate = t;

  const [customerLookupValue, setCustomerLookupValue] = useState();

  useEffect(() => {}, [props.customerBean]);
  useEffect(() => {
    if (props.customerBean) {
      setCustomerLookupValue({
        label: props.customerBean,
        value: props.customerBean,
      });
    } else {
      setCustomerLookupValue(null);
    }
  }, [props.customerBean]);

  useEffect(() => {
    if (props.customerBean == null) {
      //setCustomerLookupValue(null);
    } else {
      let obj = {
        bean: props.customerBean,
        custId: props.customerBean.custId,
        id: props.customerBean.id,
        name: props.customerBean.name,
      };
      setCustomerLookupValue({ label: obj, value: obj });
    }
  }, []);

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };
  async function getOptionsAsync(inputValue, callback) {
    let dbData = await db.customer
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("custId")
      .startsWithIgnoreCase(inputValue)
      .or("micrCode")
      .startsWithIgnoreCase(inputValue)
      .or("mobile")
      .startsWithIgnoreCase(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      if (count < 10) {
        let val = {
          id: dbData[i].id,
          name: dbData[i].name,
          custId: dbData[i].custId,
          micrCode: dbData[i].micrCode,
          bean: dbData[i],
        };
        arr.push(val);
        count++;
      } else {
        break;
      }
    }
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.custId}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.micrCode}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };
  const customerLookupChanged = (newValue) => {
    //populateCustomer(newValue.value.bean);
    setCustomerLookupValue(newValue);
    //setSaveLabel(translate("Select"));
    props.setCustomerBean(newValue.value.bean);
  };
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Card>
          <CardContent>
            <Grid container>
              <Grid item xs={1} style={{ paddingTop: "6px" }}>
                Date
              </Grid>
              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    inputFormat="MM/dd/yyyy"
                    value={props.tradingDate}
                    onChange={(event) => props.setTradingDate(event.$d)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                xs={2}
                style={{ paddingTop: "6px", paddingLeft: "20px" }}
              >
                {"Customer"}
              </Grid>
              <Grid item xs={6}>
                <AsyncSelect
                  formatOptionLabel={formatOptionLabel}
                  blurInputOnSelect
                  components={{ formatOptionLabel }}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    marginRight: "10px",
                  }}
                  placeholder={translate(
                    props.prompt ? props.prompt : "Customer Lookup"
                  )}
                  loadOptions={getOptions}
                  onChange={customerLookupChanged}
                  value={customerLookupValue}
                />
              </Grid>

              <Grid>
                <Button
                  onClick={() => {
                    // props.setShowCustomerLookupWindow(true);
                    props.setShowCustomerCrud(true);
                  }}
                >
                  New
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </ThemeProvider>
  );
}
